import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class MapService {

	constructor() { }
	

	panToWithOffset(map, latlng, offsetX, offsetY) {
		var ov = new google.maps.OverlayView();
		ov.onAdd = function () {
			var proj = this.getProjection();
			var aPoint = proj.fromLatLngToContainerPixel(latlng);
			aPoint.x = aPoint.x + offsetX;
			aPoint.y = aPoint.y + offsetY;
			map.panTo(proj.fromContainerPixelToLatLng(aPoint));
		};
		ov.draw = function () { };
		ov.setMap(map);
	}
	
	
	
	
	getMarkerPixelPosition(map:google.maps.Map, marker:google.maps.Marker):google.maps.Point
	{
		 var scale = Math.pow(2, map.getZoom());
		 var nw = new google.maps.LatLng(
				 map.getBounds().getNorthEast().lat(),
				 map.getBounds().getSouthWest().lng()
		 );
		 var worldCoordinateNW = map.getProjection().fromLatLngToPoint(nw);
		 var worldCoordinate = map.getProjection().fromLatLngToPoint(marker.getPosition());
		 var pixelOffset = new google.maps.Point(
				 Math.floor((worldCoordinate.x - worldCoordinateNW.x) * scale),
				 Math.floor((worldCoordinate.y - worldCoordinateNW.y) * scale)
		 );
		 return pixelOffset;
	}
}
